"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionType = exports.ActionSource = void 0;
var ActionSource;
(function (ActionSource) {
    ActionSource["WEB"] = "web";
    ActionSource["SMS"] = "sms";
    ActionSource["EMAIL"] = "email";
})(ActionSource = exports.ActionSource || (exports.ActionSource = {}));
var ActionType;
(function (ActionType) {
    ActionType["COMMIT"] = "commit";
    ActionType["CAN_NOT"] = "cannot";
    ActionType["DID"] = "did";
    ActionType["DID_NOT"] = "didnot";
    ActionType["SKIPPED"] = "skipped";
})(ActionType = exports.ActionType || (exports.ActionType = {}));
//# sourceMappingURL=activity.js.map